import { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { jsonLdScriptProps } from 'react-schemaorg';
import { BreadcrumbList, ListItem } from 'schema-dts';

const useSchemaBreadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs: Array<{
    href: LinkProps['href'];
    as: LinkProps['as'];
    text: string;
  }>;
}) => {
  const { locale = 'en', asPath } = useRouter();
  const localePath = locale !== 'en' ? `/${locale}` : '';

  return jsonLdScriptProps<BreadcrumbList>({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${asPath}#breadcrumb`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'WebPage',
          '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}`,
          url: `${process.env.NEXT_PUBLIC_HOST}${localePath}`,
          name: 'Home',
        },
      },
      ...breadcrumbs.map<ListItem>((item, index) => {
        const itemAsString = String(item.as);
        const asPathToShow = itemAsString ? itemAsString.split('?')[0] : '';
        return {
          '@type': 'ListItem',
          position: index + 2,
          item: {
            '@type': 'WebPage',
            '@id': `${process.env.NEXT_PUBLIC_HOST}${asPathToShow}`,
            url: `${process.env.NEXT_PUBLIC_HOST}${asPathToShow}`,
            name: item.text,
          },
        };
      }),
    ],
  });
};

export default useSchemaBreadcrumbs;
